<div class="container">
  <div class="login-container">
    <div class="login-header">
      <p>Log in to your account</p>
    </div>

    <div class="login-content">
      <button id="btnLogin" type="button" class="cursor" (click)="login()">
        <img src="okta-logo.png" alt="Okta Logo" />
        <p>Sign in with Okta</p>
      </button>
    </div>
  </div>
</div>
